import React, { useEffect, useState } from "react";

const STORAGE_KEY = "ts_seen_whatsnew_v4.3";

const HIGHLIGHTS = [
  { title: "Shareable /invite/ links", desc: "Every lifetime backer can copy a personal invite URL that pre-fills the redeem code for their friends — turn every backer into a referral engine." },
  { title: "CRM Codes-in-use dashboard", desc: "See every promo code's usage vs cap at a glance — lifetime count, refund count, and full-progress meters in real time." },
  { title: "COOL capped at 500 redemptions", desc: "The public 50%-off code now has a hard 500-user cap, protecting your margins as Top Screen grows." },
  { title: "Refund Lifetime", desc: "One-click revoke directly in the CRM Users table for chargebacks or refunds — reason is captured on every action." },
  { title: "Text-only ticker", desc: "News headlines now scroll clean and minimal — source favicons removed per popular request." },
];

/**
 * One-time modal shown to logged-in users the first time they load the dashboard after the v4.1 bump.
 * Dismissal is persisted in localStorage so subsequent visits skip it.
 */
export default function WhatsNewModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setOpen(true);
    } catch { /* localStorage blocked */ }
  }, []);

  const close = () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/70 backdrop-blur-sm"
      data-testid="whatsnew-modal"
      onClick={close}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="card-glass p-8 w-full max-w-xl border border-[#A3E635]/30"
        style={{ background: "rgba(0,0,0,0.92)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-5">
          <div>
            <span className="inline-block text-xs font-mono px-2 py-0.5 rounded-md bg-[#A3E635]/15 text-[#A3E635] mb-2">v4.3</span>
            <h2 className="font-heading text-2xl font-bold text-white">What's New in Top Screen&trade;</h2>
          </div>
          <button onClick={close} className="text-[#E8E4DC] hover:text-white p-1" aria-label="Dismiss" data-testid="whatsnew-close">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        <ul className="space-y-4 mb-6">
          {HIGHLIGHTS.map((h) => (
            <li key={h.title} className="flex items-start gap-3">
              <svg className="w-5 h-5 mt-0.5 shrink-0 text-[#A3E635]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12" /></svg>
              <div>
                <p className="text-white font-semibold text-sm">{h.title}</p>
                <p className="text-[#E8E4DC]/80 text-xs mt-0.5">{h.desc}</p>
              </div>
            </li>
          ))}
        </ul>
        <button onClick={close} className="btn-primary w-full" data-testid="whatsnew-dismiss">Got it — let's go</button>
      </div>
    </div>
  );
}
